import { render, staticRenderFns } from "./UserAuthentication.vue?vue&type=template&id=f2f88e36&scoped=true&"
import script from "./UserAuthentication.vue?vue&type=script&lang=js&"
export * from "./UserAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./UserAuthentication.vue?vue&type=style&index=0&id=f2f88e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f88e36",
  null
  
)

export default component.exports